import createApiClient from '../config/apiClient';
import API_BASE_URL from '../config/apiConfig';

const apiClient = createApiClient(API_BASE_URL);

export interface Notification {
  _id: string;
  type: string;
  refId: string;
  title: string;
  message: string;
  read: boolean;
  meta?: { name?: string; email?: string; phone?: string; serviceName?: string };
  createdAt: string;
}

export const getNotifications = async (params?: {
  page?: number;
  limit?: number;
  unreadOnly?: boolean;
}) => {
  const res = await apiClient.get('/notifications', { params });
  const body = res.data;
  return (body?.data ?? body) as {
    notifications: Notification[];
    total: number;
    unreadCount: number;
    totalPages: number;
    page: number;
  };
};

export const markNotificationRead = async (id: string) => {
  const res = await apiClient.put(`/notifications/${id}/read`);
  return res.data;
};

export const markAllNotificationsRead = async () => {
  const res = await apiClient.put('/notifications/read-all');
  return res.data;
};
